import { useQuery } from '@tanstack/react-query';

import type { ClientUpcomingEventsResponseData } from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const CLIENT_UPCOMING_EVENTS_QUERY_KEY = 'client_upcoming_events';

export const useClientUpcomingEventsQuery = (url: string) =>
  useQuery({
    queryKey: [CLIENT_UPCOMING_EVENTS_QUERY_KEY, url],
    queryFn: () =>
      HttpClient.request<ClientUpcomingEventsResponseData>({
        method: 'GET',
        url,
        headers: {
          Accept: 'application/json',
        },
      }),
    refetchOnWindowFocus: false,
  });
